module.exports = __webpack_public_path__ + "brandon_light_it-webfont.10938b6d81a5faf863f0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_light_it-webfont.woff
// module id = 941
// module chunks = 7